<template>
  <div class="w-full py-4 md:py-6">
    <slot />
  </div>
</template>
